/**
 * @file Lifetime component: destroys its entity after a fixed duration.
 *
 * Used by bullets as a safety net and by short-lived visual effects such as the
 * muzzle flash, so no system needs its own timer bookkeeping.
 */

import { Component } from '../ecs/Component.js';

export class Lifetime extends Component {
  /**
   * @param {number} seconds Time before the entity is destroyed.
   */
  constructor(seconds) {
    super();
    /** @type {number} */
    this.remaining = seconds;
    /** @type {number} */
    this.total = seconds;
  }

  /** @returns {number} Elapsed fraction of the lifetime, 0..1. */
  get progress() {
    return this.total > 0 ? 1 - this.remaining / this.total : 1;
  }

  /** @returns {void} */
  reset() {
    this.remaining = this.total;
  }
}
